import styled from 'styled-components';

export const DocumentListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  height: 100%;
`;

export const BreadcrumbText = styled.div`
  display: flex;
  align-items: center;
`;

export const DocumentListContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  overflow-y: auto;
  padding-right: 8px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.colors.highClearGray};
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.colors.lighterGray};
    border-radius: 3px;
  }
`;

export const EmptyState = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
  min-height: 200px;
`;

